import { createTrackingUtils } from "../index";
import { RouteName } from "app/routes";

const utils = createTrackingUtils({
  name: "flights_apex_web_bf_features_in_single_list",
  stages: {
    main: 1,
    mdot: 2,
    desktop: 3,
    bf_on_sr: 4,
    branded_fares: 5,
    check_and_pay: 6,
    excluded_features_required: 7
  },
  goals: {},
  defaultStage: 1
});

const trackStages = (isMobile: boolean, routeName: RouteName, excludedFeaturesRequiredByAirline?: boolean) => {
  if (isMobile) utils.stages.mdot();
  if (!isMobile) utils.stages.desktop();
  if (routeName === "searchresults") utils.stages.bf_on_sr();
  if (routeName === "checkout-fare") utils.stages.branded_fares();
  if (routeName === "checkout-payment") utils.stages.check_and_pay();
  if (excludedFeaturesRequiredByAirline) utils.stages.excluded_features_required();
};

export default { ...utils, trackStages };
